import React from 'react';

const CustomerLogin = () => {
    return (
        <div>
            <h1>customer login</h1>
        </div>
    );
};

export default CustomerLogin;